import { Category, Product } from '../types/content'

export const categories: Category[] = [
  {
    name: {
      nl: 'Verse markt',
      en: 'Fresh market',
    },
    detail: {
      nl: 'Fruit · Groenten · Slagerij',
      en: 'Fruit · Vegetables · Meat',
    },
    image:
      'https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=800&q=85',
    to: '/categories#fresh-fruits-vegetables',
  },
  {
    name: {
      nl: 'Kruidenierswaren',
      en: 'Food & pantry',
    },
    detail: {
      nl: 'Rijst · Oliën · Conserven',
      en: 'Rice · Oil · Canned food',
    },
    image:
      'https://images.unsplash.com/photo-1601050690597-df0568f70950?auto=format&fit=crop&w=1000&q=90',
    to: '/categories#food-and-pantry',
  },
  {
    name: {
      nl: 'Dranken, wijn & sterkedrank',
      en: 'Beverages, wine & spirits',
    },
    detail: {
      nl: 'Water · Frisdrank · Koffie · Thee · Wijn',
      en: 'Water · Soft drinks · Coffee · Tea · Wine',
    },
    image:
      'https://images.unsplash.com/photo-1534353473418-4cfa6c56fd38?auto=format&fit=crop&w=1000&q=90',
    to: '/categories#beverages-wine-and-spirits',
  },
  {
    name: {
      nl: 'Gezondheid & verzorging',
      en: 'Health & personal care',
    },
    detail: {
      nl: 'Gezondheid · Beauty · Baby',
      en: 'Medical · Beauty · Baby',
    },
    image:
      'https://images.unsplash.com/photo-1584515933487-779824d29309?auto=format&fit=crop&w=800&q=85',
    to: '/categories#health-and-medical',
  },
  {
    name: {
      nl: 'Elektro & toestellen',
      en: 'Electricals & appliances',
    },
    detail: {
      nl: 'Tv · Toestellen · Mobiel',
      en: 'TVs · Appliances · Mobile',
    },
    image:
      'https://images.unsplash.com/photo-1558002038-1055907df827?auto=format&fit=crop&w=800&q=85',
    to: '/categories#electricals-and-appliances',
  },
  {
    name: {
      nl: 'Huis & textiel',
      en: 'Home & textiles',
    },
    detail: {
      nl: 'Lakens · Kussens · Decoratie',
      en: 'Bedding · Pillows · Décor',
    },
    image:
      'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&w=800&q=85',
    to: '/categories#bedding-and-home-textiles',
  },
]

export const products: Product[] = [
  {
    name: {
      nl: 'Intense koffieselectie',
      en: 'Signature blend coffee',
    },
    type: {
      nl: 'Dranken',
      en: 'Beverages',
    },
    brand: 'Nescafé',
    image:
      'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?auto=format&fit=crop&w=800&q=85',
  },
  {
    name: {
      nl: 'Extra vierge olijfolie',
      en: 'Extra virgin olive oil',
    },
    type: {
      nl: 'Kruidenierswaren',
      en: 'Food & pantry',
    },
    brand: 'Terra Verde',
    image:
      'https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?auto=format&fit=crop&w=800&q=85',
  },
  {
    name: {
      nl: 'Sprankelend mineraalwater',
      en: 'Sparkling mineral water',
    },
    type: {
      nl: 'Mineraalwater',
      en: 'Mineral water',
    },
    brand: 'AquaPure',
    image:
      'https://images.unsplash.com/photo-1550505095-81378a674395?auto=format&fit=crop&w=800&q=85',
  },
  {
    name: {
      nl: 'Rodewijncollectie',
      en: 'Reserve red wine collection',
    },
    type: {
      nl: 'Wijn',
      en: 'Wine',
    },
    brand: 'Brugse Kelders',
    image:
      'https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?auto=format&fit=crop&w=800&q=85',
  },
  {
    name: {
      nl: 'Katoenen beddengoedset',
      en: 'Soft cotton bedding set',
    },
    type: {
      nl: 'Huishoudlinnen',
      en: 'Home textiles',
    },
    brand: 'Home Comfort',
    image:
      'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&w=800&q=85',
  },
  {
    name: {
      nl: 'Snoerloze gereedschapsset',
      en: 'Cordless power tool kit',
    },
    type: {
      nl: 'Doe-het-zelf',
      en: 'DIY & hardware',
    },
    brand: 'BuildPro',
    image:
      'https://images.unsplash.com/photo-1504148455328-c376907d081c?auto=format&fit=crop&w=800&q=85',
  },
  {
    name: {
      nl: 'EHBO- & verzorgingskit',
      en: 'First aid & medical kit',
    },
    type: {
      nl: 'Gezondheid',
      en: 'Health',
    },
    brand: 'MediSure',
    image:
      'https://images.unsplash.com/photo-1584515933487-779824d29309?auto=format&fit=crop&w=800&q=85',
  },
  {
    name: {
      nl: 'Professionele pannenset',
      en: 'Professional cookware set',
    },
    type: {
      nl: 'Keuken & tafel',
      en: 'Kitchen & dining',
    },
    brand: 'ChefWorks',
    image:
      'https://images.unsplash.com/photo-1556911220-e15b29be8c8f?auto=format&fit=crop&w=800&q=85',
  },
]
